import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Divider, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

// import * as React from "react";
// ... your imports

export default function ProfiLossUtils() {
  const [value, setValue] = React.useState("1");
  const [userData, setUserData] = React.useState(null);

  const { auth, accountMode } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const isFetchingRef = React.useRef(false); // track ongoing fetch

  const SINGLE_USER_ENDPOINT = `/singleuser/${auth?.id}`;
  const DEMO_SINGLE_USER_ENDPOINT = `/demo-singleuser/${auth?.id}`;
  const activeEndPoint =
    accountMode === "real" ? SINGLE_USER_ENDPOINT : DEMO_SINGLE_USER_ENDPOINT;
  const loadSkeleton = (
    <span className="animate-pulse  text-gray-400">00.00</span>
  );

  React.useEffect(() => {
    let isMounted = true;
    let intervalId;

    const fetchUserData = async () => {
      console.log(activeEndPoint);
      if (isFetchingRef.current) return; // skip if already fetching
      isFetchingRef.current = true;
      try {
        const response = await axiosPrivate(activeEndPoint);
        if (response.status === 200 && isMounted) {
          setUserData(response.data?.foundUser || null);
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      } finally {
        isFetchingRef.current = false;
      }
    };

    // initial fetch
    fetchUserData();

    // set polling every 5 seconds
    intervalId = setInterval(fetchUserData, 5000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [axiosPrivate, activeEndPoint]);

  // Memoized values
  const userBalance = React.useMemo(
    () => userData?.balance ?? loadSkeleton,
    [userData],
  );

  const demoUserBalance = React.useMemo(
    () => userData?.demoBalance ?? loadSkeleton,
    [userData],
  );
  const userLoss = React.useMemo(
    () => userData?.loss ?? loadSkeleton,
    [userData],
  );

  const demoUserLoss = React.useMemo(
    () => userData?.demoLoss ?? loadSkeleton,
    [userData],
  );
  const userProfit = React.useMemo(
    () => userData?.profit ?? loadSkeleton,
    [userData],
  );

  const demoUserProfit = React.useMemo(
    () => userData?.demoProfit ?? loadSkeleton,
    [userData],
  );
  const userRecentInvestment = React.useMemo(
    () => userData?.recentInvestment ?? loadSkeleton,
    [userData],
  );

  const demoUserRecentInvestment = React.useMemo(
    () => userData?.demoRecentInvestment ?? loadSkeleton,
    [userData],
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const numFormatter = (num) => {
    const number = Number(num);
    const formatter = new Intl.NumberFormat("en-US"); // or your locale
    return formatter.format(number); // "500,000"
  };

  // numFormatter();

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="Account Summary Tabs">
            <Tab label="Profit" value="1" sx={{ color: "green" }} />
            <Tab label="Loss" value="2" sx={{ color: "red" }} />
            {/* <Tab label="Loss" value="3" />
                        <Tab label="Profit" value="4" /> */}
          </TabList>
        </Box>

        <TabPanel value="1">
          <Typography
            variant="h5"
            sx={{ textAlign: "left", fontSize: "1.7rem" }}
          >
            $
            {accountMode === "real"
              ? isNaN(parseFloat(Number(userProfit).toFixed(2)))
                ? loadSkeleton
                : numFormatter(parseFloat(Number(userProfit).toFixed(2)))
              : isNaN(parseFloat(Number(demoUserProfit).toFixed(2)))
                ? loadSkeleton
                : numFormatter(parseFloat(Number(demoUserProfit).toFixed(2)))}
            <TrendingUpIcon
              sx={{ color: "green", fontSize: "1.5rem", mr: "0.4rem" }}
            />
          </Typography>
        </TabPanel>
        {/* <TabPanel value="2">
                    <Box>
                        <Typography
                            variant="h5"
                            sx={{ textAlign: "left", fontSize: "1.7rem" }}>
                            ${accountMode === "real" ? userProfit : demoUserProfit}
                        </Typography>
                        <Divider sx={{ width: "20%", background: "green", my: "0.4rem" }} />
                        <Typography
                            variant="h5"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                textAlign: "left",
                                fontSize: "1.1rem",
                                fontFamily: "monospace",
                            }}>
                            <TrendingUpIcon
                                sx={{ color: "green", fontSize: "1.5rem", mr: 1 }}
                            />
                            65%
                        </Typography>
                    </Box>
                </TabPanel> */}
        {/* <TabPanel value="3">
                    <Box>
                        <Typography
                            variant="h5"
                            sx={{ textAlign: "left", fontSize: "1.7rem" }}>
                            ${userLoss}
                        </Typography>
                        <Divider sx={{ width: "20%", background: "red", my: "0.4rem" }} />
                        <Typography
                            variant="h5"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                textAlign: "left",
                                fontSize: "1.1rem",
                                fontFamily: "monospace",
                            }}>
                            <TrendingDownIcon
                                sx={{ color: "red", fontSize: "1.5rem", mr: 1 }}
                            />
                            35%
                        </Typography>
                    </Box>
                </TabPanel> */}
        <TabPanel value="2">
          <Typography
            variant="h5"
            sx={{ textAlign: "left", fontSize: "1.7rem" }}
          >
            $
            {accountMode === "real"
              ? isNaN(parseFloat(Number(userLoss).toFixed(2)))
                ? loadSkeleton
                : parseFloat(Number(userLoss).toFixed(2))
              : isNaN(parseFloat(Number(demoUserLoss).toFixed(2)))
                ? loadSkeleton
                : parseFloat(Number(demoUserLoss).toFixed(2))}
            <TrendingDownIcon
              sx={{ color: "red", fontSize: "1.5rem", mx: "0.4rem" }}
            />
          </Typography>
        </TabPanel>
      </TabContext>
    </Box>
  );
}

// export default function AccountSumUtils() {
// 	const [value, setValue] = React.useState("1");
// 	const [userData, setUserData] = React.useState(null);

// 	const { auth } = useAuth();
// 	const axiosPrivate = useAxiosPrivate();

// 	const SINGLE_USER_ENDPOINT = `/singleuser/${auth?.id}`;

// 	// Fetch user data on component mount

// 	React.useEffect(() => {
// 		let isMounted = true;
// 		let intervalId;

// 		const fetchUserData = async () => {
// 			try {
// 				const response = await axiosPrivate(SINGLE_USER_ENDPOINT);
// 				if (response.status === 200 && isMounted) {
// 					setUserData(response.data?.foundUser || null);
// 				}
// 			} catch (error) {
// 				console.error("Failed to fetch user data:", error);
// 			}
// 		};

// 		fetchUserData(); // initial load

// 		// Poll every 5 seconds
// 		intervalId = setInterval(fetchUserData, 5000);

// 		return () => {
// 			isMounted = false;
// 			clearInterval(intervalId);
// 		};
// 	}, [axiosPrivate, SINGLE_USER_ENDPOINT]);
// 	// React.useEffect(() => {
// 	// 	let isMounted = true; // To prevent state update if unmounted

// 	// 	const fetchUserData = async () => {
// 	// 		try {
// 	// 			const response = await axiosPrivate(SINGLE_USER_ENDPOINT);
// 	// 			if (response.status === 200 && isMounted) {
// 	// 				setUserData(response.data?.foundUser || null);
// 	// 			}
// 	// 		} catch (error) {
// 	// 			console.error("Failed to fetch user data:", error);
// 	// 		}
// 	// 	};

// 	// 	fetchUserData();

// 	// 	return () => {
// 	// 		isMounted = false; // Cleanup flag
// 	// 	};
// 	// }, [axiosPrivate, SINGLE_USER_ENDPOINT]);

// 	// Derive display values with default fallback
// 	const userBalance = React.useMemo(
// 		() => userData?.balance ?? "Loading",
// 		[userData]
// 	);
// 	const userLoss = React.useMemo(() => userData?.loss ?? "Loading", [userData]);
// 	const userProfit = React.useMemo(
// 		() => userData?.profit ?? "Loading",
// 		[userData]
// 	);
// 	const userRecentInvestment = React.useMemo(
// 		() => userData?.recentInvestment ?? "Loading",
// 		[userData]
// 	);

// 	const handleChange = (event, newValue) => {
// 		setValue(newValue);
// 	};

// 	return (
// 		<Box sx={{ width: "100%", typography: "body1" }}>
// 			<TabContext value={value}>
// 				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
// 					<TabList onChange={handleChange} aria-label="Account Summary Tabs">
// 						<Tab label="Balance" value="1" />
// 						<Tab label="Profit" value="2" />
// 						<Tab label="Loss" value="3" />
// 						<Tab label="Recent Investment" value="4" />
// 					</TabList>
// 				</Box>

// 				<TabPanel value="1">
// 					<Typography
// 						variant="h5"
// 						sx={{ textAlign: "left", fontSize: "1.7rem" }}>
// 						${userBalance}
// 					</Typography>
// 				</TabPanel>

// 				<TabPanel value="2">
// 					<Box>
// 						<Typography
// 							variant="h5"
// 							sx={{
// 								textAlign: "left",
// 								fontSize: "1.7rem",
// 							}}>
// 							${userProfit}
// 						</Typography>
// 						<Divider sx={{ width: "20%", background: "green", my: "0.4rem" }} />
// 						<Typography
// 							variant="h5"
// 							sx={{
// 								display: "flex",
// 								alignItems: "center",
// 								textAlign: "left",
// 								fontSize: "1.1rem",
// 								fontFamily: "monospace",
// 							}}>
// 							<TrendingUpIcon
// 								sx={{
// 									color: "green",
// 									fontSize: "1.5rem",
// 									mr: 1,
// 								}}
// 							/>
// 							65%
// 						</Typography>
// 					</Box>
// 				</TabPanel>

// 				<TabPanel value="3">
// 					<Box>
// 						<Typography
// 							variant="h5"
// 							sx={{
// 								textAlign: "left",
// 								fontSize: "1.7rem",
// 							}}>
// 							${userLoss}
// 						</Typography>
// 						<Divider sx={{ width: "20%", background: "red", my: "0.4rem" }} />
// 						<Typography
// 							variant="h5"
// 							sx={{
// 								display: "flex",
// 								alignItems: "center",
// 								textAlign: "left",
// 								fontSize: "1.1rem",
// 								fontFamily: "monospace",
// 							}}>
// 							<TrendingDownIcon
// 								sx={{
// 									color: "red",
// 									fontSize: "1.5rem",
// 									mr: 1,
// 								}}
// 							/>
// 							35%
// 						</Typography>
// 					</Box>
// 				</TabPanel>

// 				<TabPanel value="4">
// 					<Typography
// 						variant="h5"
// 						sx={{ textAlign: "left", fontSize: "1.7rem" }}>
// 						${userRecentInvestment}
// 					</Typography>
// 				</TabPanel>
// 			</TabContext>
// 		</Box>
// 	);
// }
